import React from 'react'

import PosSubscriptions from 'pages/parts/PosSubscriptions'

// Партнёр видит только своих клиентов: область ставит сервер по токену
function Index() {
	return <PosSubscriptions mode="partner" />
}

export default Index
